<template>
  <v-container>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <!-- メッセージ -->
      <div class="text-h6 pa-4 text-center">
        招待したいメンバーのメールアドレスを入力し、送信してください。
      </div>

      <div>
        <validation-provider v-slot="{ errors }" name="メールアドレス" rules="required|email">
          <v-text-field
            v-model="email"
            label="メールアドレス"
            type="email"
            outlined
            dense
            :error-messages="errors"
          >
          </v-text-field>
        </validation-provider>
      </div>

      <!-- 送信ボタン -->
      <v-btn
        color="primary"
        elevation="0"
        block
        :disabled="invalid || isProcessing"
        @click="sendEmail"
      >
        送信
      </v-btn>
    </validation-observer>
  </v-container>
</template>

<script>
import { MESSAGES } from "@/const/message";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import { mapActions } from "vuex";

export default {
  name: "EmailInvitation",
  mixins: [errorHandlerMixin()],
  data: () => ({
    email: "",

    // 処理中フラグ
    isProcessing: false,
  }),
  computed: {},
  created() {},
  methods: {
    ...mapActions("api", ["incrementRunningApiCount", "decrementRunningApiCount"]),

    // 招待メール送信
    async sendEmail() {
      try {
        this.isProcessing = true;
        this.incrementRunningApiCount();

        // 招待メールを送信
        const func = this.$httpsCallable(this.$functions, "emailinvitation");
        await func({ email: this.email });

        this.decrementRunningApiCount();

        this.$store.dispatch("snackbar/openSnackbar", {
          text: `招待メールを送信しました`,
          color: "success",
        });
        this.$router.push(`/`).catch(() => {});
      } catch (err) {
        if (err.message === "auth/email-used") {
          this.showError(MESSAGES.ERRORS.EMAIL_USED);
        } else {
          this.showError(MESSAGES.ERRORS.UNEXPECTED);
        }
      } finally {
        this.isProcessing = false;
      }
    },
  },
};
</script>
